import { render } from "./BotaoExcluir.vue?vue&type=template&id=06fb46e6&ts=true"
import script from "./BotaoExcluir.vue?vue&type=script&lang=ts"
export * from "./BotaoExcluir.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Botoes/BotaoExcluir.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "06fb46e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('06fb46e6', __exports__)) {
    api.reload('06fb46e6', __exports__)
  }
  
  module.hot.accept("./BotaoExcluir.vue?vue&type=template&id=06fb46e6&ts=true", () => {
    api.rerender('06fb46e6', render)
  })

}


export default __exports__